/**
 * created by lei lei on 2020/5/18
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Icon, Popconfirm, message, Modal, Tooltip } from "antd";
import {uuid} from '../../../utils/index'

export default class FlowchartAndPreview extends Component {
    static defaultProps = {
        checkedKey:'checked'
    }
    static propTypes = {
        dataSource: PropTypes.array.isRequired,//数据源
        checkedData: PropTypes.func.isRequired,//选中的数据源
        clickShowBindColumn: PropTypes.func.isRequired,//点击流程展示绑定的栏目
        titleKey: PropTypes.string.isRequired,//栏目显示的标题键值
        checkedKey: PropTypes.string,//勾选按钮状态对应字段的键值
        flowchartKey: PropTypes.string.isRequired,//流程的标识，id,code类的键值
        chooseTreeData:PropTypes.array.isRequired,//流程栏目树带过来的数据，必传项
        previewKey:PropTypes.string.isRequired,//点击预览使用的字段键值
    }

    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            checkedData: [],
            isFirst: true,
            visible:false,
            previewUrl:'',
            modalTitle:'',
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
       if (this.state.isFirst) {
            this.state.dataSource = this.props.dataSource
            this.state.isFirst = false
           this.addCheck(this.props.dataSource)
            this.setState({})
        }
    }
    render() {

        if (this.state.isFirst) {
            this.state.dataSource = this.props.dataSource
            this.state.isFirst = false
        }
        return (
            <div>
                {this.props.dataSource.map((item, index) => {
                   return (
                        <div key={item[this.props.flowchartKey]} style={{marginBottom: '10px', display: 'flex'}}>
                            <div style={{
                                padding: 10,
                                border: '1px solid #F0F0F0',
                                width: 300,
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',cursor: 'pointer'
                            }} title={item[this.props.titleKey]}>
                                {item[this.props.titleKey]}
                            </div>
                            {
                                // this.props.chooseTreeData<1?
                                //     <Icon type="check-circle" id={'bindBtn'} onClick={()=>this.onClickCheckBox(item, index)} style={{color:'gray',fontSize: 20,padding:12}}/>
                                //     :
                                <Popconfirm
                                    title={`确认要绑定${item[this.props.titleKey].length > 30 ? item[this.props.titleKey].substr(0, 30) + "..." + item[this.props.titleKey].substr(-5) : item[this.props.titleKey]}流程图?`}
                                    onConfirm={() => {
                                        this.onClickCheckBox(item, index)
                                    }}
                                    onCancel={() => {
                                        this.onCancel(item, index)
                                    }}
                                    okText="确认"
                                    cancelText="取消"
                                >
                                    <Tooltip placement="topLeft" title={<div>绑定“<span
                                        style={{color: "red"}}>{item[this.props.titleKey]}</span>”流程</div>}>
                                        <Icon type="check-circle" style={{color: 'gray', fontSize: 20, padding: 12}}/>
                                    </Tooltip>
                                </Popconfirm>
                            }
                            <Tooltip placement="topLeft"
                                     title={<div>查看“<span style={{color: "red"}}>{item[this.props.titleKey]}</span>”流程
                                     </div>}>
                                <Icon type="eye" style={{fontSize: 20, padding: 12, color: 'gray'}} onClick={() => {
                                    this.setState({
                                        visible: true,
                                        previewUrl: item[this.props.previewKey],
                                        modalTitle: item[this.props.titleKey],
                                    })
                                }}/>
                            </Tooltip>
                            <Tooltip placement="topLeft"
                                     title={<div>展示与“<span style={{color: "red"}}>{item[this.props.titleKey]}</span>”流程关联的节点
                                     </div>}>
                                <Icon type="link"
                                      style={{fontSize: 20, color: item.correlation ? '#0050b3' : 'gray', padding: 12}}
                                      onClick={() => {
                                          this.props.clickShowBindColumn && this.props.clickShowBindColumn(item)
                                      }}/>
                            </Tooltip>
                        </div>
                    )
                })}
                
                <Modal
                    title={this.state.modalTitle.length>30?this.state.modalTitle.substring(0,30)+'...':this.state.modalTitle}
                    visible={this.state.visible}
                    onOk={()=>{}}
                    width={1200}
                    onCancel={()=>{this.setState({visible:false})}}
                    destroyOnClose={true}
                    footer={null}
                >
                    <img style={{maxWidth:1100,maxHeight:700}} src={this.state.previewUrl}/>
                   {/*<iframe style={{width:750,height:400}} src={this.state.previewUrl} />*/}
                </Modal>
            </div>
        )
    }

    onClickCheckBox(item, index) {
        let checkedKey = this.props.checkedKey
        if(this.props.chooseTreeData.length<1){
            message.destroy()
            message.error('请选择左侧业务节点后再绑定流程！')
            return
        }else{
            this.state.dataSource.forEach((Item, Index) => {
               Item[checkedKey] =false
            })
            this.props.dataSource[index][checkedKey] =true
            this.setState({})
            this.props.checkedData && this.props.checkedData(item)
        }
    }
    onCancel(item, index){
        let checkedKey = this.props.checkedKey
        this.props.dataSource[index][checkedKey] =false
        this.state.checkedData=[]
        this.setState({})
    }
    addCheck(data){
       data.forEach((item)=>{
            item.checked=false
        })
    }

}